import Swal from 'sweetalert2';
import { t } from 'i18next';

const HTML_ENTITIES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/// O html do alerta é montado à mão: nome digitado por usuário não pode virar marcação.
const escapeHtml = (value: string) => value.replace(/[&<>"']/g, (char) => HTML_ENTITIES[char]);

/// `name` é o que será excluído, como a pessoa o conhece; `detail` é a consequência, em linha à parte.
function showConfirmDelete(
    id: string,
    deleteFunction: (id: string) => void,
    name?: string,
    detail?: string,
    darkMode?: boolean
) {
    const question = name
        ? t('general.excluirNome', { nome: escapeHtml(name) })
        : t('general.confirmarExclusao');

    Swal.fire({
        title: `<h3 style="color: #ddaf16; margin-top: -4%;"><strong>${t('general.atencao')}</strong></h3>`,
        html: `<h3>${question}</h3>`
            + (detail ? `<p style="font-size: 14px; margin-top: 8px;">${escapeHtml(detail)}</p>` : ''),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#df4343',
        cancelButtonColor: darkMode ? '#405568' : '#252527',
        cancelButtonText: t('general.cancelar'),
        confirmButtonText: t('general.excluir'),
        reverseButtons: true,
        background: darkMode ? '#141c2b' : '#ffffff',
        color: darkMode ? '#ffffff' : '#333333',
    }).then((result) => {
        if (result.isConfirmed) {
            deleteFunction(id);
        }
    });
}

export default showConfirmDelete;
